import { addErrorLog } from "Logger/logger";
import { insertQuery, getQuery, deleteQuery, updateQuery } from "./UdasWrapper";
import { uncompressRows } from "helpers/common";

export const insertIntegrations = async (input) => {
  const data = JSON.stringify({
    query: `mutation InsertIntegrations($input: IntegrationInput!) {
      insertIntegrations(input: $input) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: { input }
  });

  try {
    return (await insertQuery(data))?.insertIntegrations?.resultObject;
  } catch (error) {
    addErrorLog("mutation InsertIntegrations", error);

    return null;
  }
};

export const deleteIntegration = async (input) => {
  const data = JSON.stringify({
    query: `mutation DeleteIntegrations($tenant_id: String!, $integration_id: String!) {
      deleteIntegrations( tenant_id: $tenant_id, integration_id: $integration_id) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: input
  });

  try {
    const result = await deleteQuery(data);

    return result?.deleteIntegrations;
  } catch (error) {
    addErrorLog("mutation DeleteIntegrations", error);

    return null;
  }
};

export const updateIntegration = async (input) => {
  const data = JSON.stringify({
    query: `mutation UpdateIntegrations($input: IntegrationInput!) {
      updateIntegrations(input: $input) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      input
    }
  });

  try {
    return (await updateQuery(data))?.updateIntegrations;
  } catch (error) {
    addErrorLog("mutation UpdateIntegrations", error);

    return null;
  }
};

export const getIntegrationByUser = async (input) => {
  const data = JSON.stringify({
    query: `query GetIntegrationByUser($tenant_id: String!, $user_id: String!) {
      getIntegrationByUser(
        tenant_id: $tenant_id,
        user_id: $user_id
      ) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenant_id: input.tenant_id,
      user_id: input.user_id
    }
  });

  try {
    const result = await getQuery(data);

    return result?.getIntegrationByUser?.resultObject;
  } catch (error) {
    addErrorLog("query GetIntegrationByUser", error);

    return null;
  }
};

export const insertSharedIntegration = async (tenant_id, input) => {
  try {
    const data = JSON.stringify({
      query: `mutation InsertSharedIntegrations($tenant_id: String!, $input: [SharedIntegrationsInput]) {
  insertSharedIntegrations(tenant_id: $tenant_id, input: $input) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: { tenant_id, input }
    });
    return (await insertQuery(data))?.insertSharedIntegrations;
  } catch (error) {
    addErrorLog("mutation InsertSharedIntegrations", error);
    return null;
  }
};

export const getOwnedSharedIntegrations = async (auth0_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetSharedIntegrationByOwnerId($ownerId: String!) {
  getSharedIntegrationByOwnerId(owner_id: $ownerId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: { ownerId: auth0_id }
    });
    const result = await getQuery(data);
    return result?.getSharedIntegrationByOwnerId?.resultObject;
  } catch (error) {
    addErrorLog("query GetSharedIntegrationByOwnerId", error);
    return null;
  }
};

export const getSharedIntegrationBySharedUserId = async (auth0_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetSharedIntegrationBySharedUserId($userId: String!) {
  getSharedIntegrationBySharedUserId(user_id: $userId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        userId: auth0_id
      }
    });
    const result = await getQuery(data);
    return result?.getSharedIntegrationBySharedUserId?.resultObject;
  } catch (error) {
    addErrorLog("query GetSharedIntegrationBySharedUserId", error);
    return null;
  }
};

export const getSharedIntegrations = async (tenant_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetSharedIntegrations($tenantId: String!) {
  getSharedIntegrations(tenant_id: $tenantId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        tenantId: tenant_id
      }
    });

    const result = await getQuery(data);
    return result?.getSharedIntegrations?.resultObject;
  } catch (error) {
    addErrorLog("query GetSharedIntegrations", error);
    return null;
  }
};

export const getIntegrations = async (tenant_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetIntegrations($tenantId: String!) {
  getIntegrations(tenant_id: $tenantId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        tenantId: tenant_id
      }
    });

    const result = await getQuery(data);
    return result?.getIntegrations?.resultObject;
  } catch (error) {
    addErrorLog("query GetIntegrations", error);
    return null;
  }
};

export const deleteSharedIntegrations = async (tenant_id, input) => {
  try {
    const data = JSON.stringify({
      query: `mutation DeleteSharedIntegrations($tenant_id: String!, $input: [DeleteSharedIntegrationsInput]) {
  deleteSharedIntegrations(tenant_id: $tenant_id, input: $input) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: { tenant_id, input }
    });
    const result = await deleteQuery(data);
    return result?.deleteSharedIntegrations;
  } catch (error) {
    addErrorLog("mutation DeleteSharedIntegrations", error);
    return null;
  }
};

export const updateSharedIntegration = async (input) => {
  try {
    const data = JSON.stringify({
      query: `mutation UpdateSharedIntegration($input: UpdateSharedIntegrationsInput) {
  updateSharedIntegration(input: $input) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: { input }
    });
    return (await updateQuery(data))?.updateSharedIntegration;
  } catch (error) {
    addErrorLog("mutation updateSharedIntegration", error);
    return null;
  }
};

export const getIntegrationFlows = async (tenant_id, integration_ids) => {
  let data = JSON.stringify({
    query: `query GetIntegrationFlows($tenant_id: String!, $integration_ids: [String]!) {
      getIntegrationFlows(tenant_id: $tenant_id, integration_ids: $integration_ids) {
        id
        name
        steps
      }
    }`,
    variables: { tenant_id, integration_ids }
  });
  try {
    const result = (await getQuery(data))?.getIntegrationFlows;

    return uncompressRows(result);
  } catch (error) {
    addErrorLog("query Integration Flows", error, tenant_id);
  }
};